import { app } from '../../../app';
import { Controller } from './google-marketplace-configuration.controller';

app.component('googleMarketplaceConfiguration', {
    templateUrl: require('./google-marketplace-configuration.html'),
    controller: Controller,
});


// WEBPACK FOOTER //
// ./src/portal/states/company/google-marketplace-configuration/google-marketplace-configuration.component.js